import { render, staticRenderFns } from "./HistoryNavigation.vue?vue&type=template&id=76460798"
import script from "./HistoryNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryNavigation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports